var EKeyCode;
(function (EKeyCode) {
    EKeyCode[EKeyCode["One"] = 49] = "One";
    EKeyCode[EKeyCode["Q"] = 81] = "Q";
    EKeyCode[EKeyCode["LAlt"] = 17] = "LAlt";
    EKeyCode[EKeyCode["RAlt"] = 18] = "RAlt";
    EKeyCode[EKeyCode["M"] = 77] = "M";
    EKeyCode[EKeyCode["Comma"] = 188] = "Comma";
    EKeyCode[EKeyCode["P"] = 80] = "P";
    EKeyCode[EKeyCode["SZ"] = 189] = "SZ";
    EKeyCode[EKeyCode["Left"] = 37] = "Left";
    EKeyCode[EKeyCode["Down"] = 40] = "Down";
    EKeyCode[EKeyCode["Space"] = 32] = "Space";
    EKeyCode[EKeyCode["Enter"] = 13] = "Enter";
    EKeyCode[EKeyCode["Y"] = 89] = "Y";
    EKeyCode[EKeyCode["X"] = 88] = "X";
})(EKeyCode || (EKeyCode = {}));
var EMouseClick;
(function (EMouseClick) {
    EMouseClick["Left"] = "Left";
    EMouseClick["Right"] = "Right";
})(EMouseClick || (EMouseClick = {}));
export { EKeyCode, EMouseClick };
